export const settingReducer = (state, action) => {
  switch (action.type) {
    case "SET_TABLE_DATA":
      return {
        ...state,
        tableData: action.payload.data,
        totalCount: action.payload.totalCount,
      };

    default:
      return state;
  }
};
